import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Store actions/selectors
import { adminOrderListSelector } from 'store/Admin/OrderList';
import {
  fetchAdminOrderDisplay,
  fetchAdminTextOrderDisplay,
  fetchAdminOrderLineDisplay,
} from 'store/Admin/OrderDisplay/features';
import { setStatus } from 'store/Admin/OrderDisplay';
import { setOrderId, setOrderType } from 'store/Admin/Analyser';

// Hooks & utils
import { ORDERSTATUS } from 'utils/Constants';

// UI Components
import OrdersTable from 'components/shared/OrdersTable';

import './order.css';

export default function SmartWithReviewOrders() {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { smartWithReviewOrders, isLoading, isError } = useSelector(
    adminOrderListSelector
  );

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
  }, []);

  return (
    <OrdersTable
      title={t('Commandes avec révision')}
      orderStatus={ORDERSTATUS.SMART_WITH_REVIEW}
      orders={smartWithReviewOrders}
      isLoading={isLoading}
      isError={isError}
      fetchDisplayData={(id, orderType) => {
        dispatch(setStatus(ORDERSTATUS.SMART_WITH_REVIEW));
        dispatch(setOrderId(id));
        dispatch(setOrderType(orderType));
        dispatch(fetchAdminOrderDisplay(id));
        dispatch(fetchAdminTextOrderDisplay(id));
        dispatch(fetchAdminOrderLineDisplay(id));
      }}
      onRowClickRedirectPath="/Admin/DetailsDeLaCommande"
    />
  );
}
